import React, { useContext } from 'react';
import { Auth } from 'aws-amplify';
import { Link, useLocation, useHistory } from 'react-router-dom';
import { Menu, Dropdown, Button } from 'antd';
import { DownOutlined } from '@ant-design/icons';
import UserContext from '../../contexts/user.context';
import './TopNav.css';

interface IProps {
  collapsed: boolean;
}

const TopNav: React.FC<IProps> = (props: IProps) => {
  const { user } = useContext(UserContext);
  const location = useLocation();
  const history = useHistory();
  const { collapsed } = props;
  const userName =
    user.attributes.given_name !== null &&
    user.attributes.given_name !== undefined
      ? user.attributes.given_name
      : 'User';

  const logOut = async () => {
    await Auth.signOut();
    history.push('/');
  };

  const subMenu = (
    <Menu
      selectedKeys={[location!.pathname]}
      style={{ backgroundColor: '#23282d' }}
    >
      <Menu.Item key="/profile" className="TopNav-submenu-item">
        <Link to="/profile" className="TopNav-submenu-link">
          User Profile
        </Link>
        <div className="TopNav-submenu-pointer" />
      </Menu.Item>
      <Menu.Item key="/notifications" className="TopNav-submenu-item">
        <Link to="/notifications" className="TopNav-submenu-link">
          {/* <span className="TopNav-submenu-badge">
            <BellOutlined />
            <span>12</span>
          </span> */}
          Notifications
        </Link>
      </Menu.Item>
    </Menu>
  );

  return (
    <Menu
      selectedKeys={[location!.pathname]}
      mode="horizontal"
      style={{
        lineHeight: '45px',
      }}
      className="TopNav"
    >
      <Menu.Item key="" style={collapsed ? {} : { visibility: 'hidden' }}>
        <b>Ending the HIV Epidemic</b> — Tracker
        <Link to="/" />
      </Menu.Item>
      <Menu.Item
        key="/logout"
        onClick={logOut}
        style={{ float: 'right', position: 'relative' }}
      >
        Log Out
      </Menu.Item>
      <Dropdown
        overlay={subMenu}
        placement="bottomRight"
        arrow
        className="TopNav-dropdown"
      >
        <Button className="TopNav-hello-button">
          Hello, {userName} <DownOutlined />
        </Button>
      </Dropdown>
    </Menu>
  );
};

export default TopNav;
